import { GeneralStyle } from '@website-builder/model/style/general-style';

export class VideoStyle extends GeneralStyle {
  boxDecoration = '';
  inverseStyle = '';
  boxShadow = '';

  static normalize(styles: Partial<VideoStyle>): VideoStyle {
    const generalStyles: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new VideoStyle();

    Object.assign(pureStyles, generalStyles);

    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.inverseStyle = styles.inverseStyle ?? pureStyles.inverseStyle;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;

    return pureStyles;
  }
}
